<template>
  <Loader v-if="loading"/>
  <TCarousel
    v-else
    header-hidden
    class="community-carousel"
  >
    <TLink
      v-for="user in list"
      :key="user.id"
      :to="{ name: 'Profile', params: { username: user.username } }"
      class="slide"
      target="_blank"
    >
      <TAvatar
        class="slide__face"
        :src="user.avatarUrl"
        :name="user.username"
      />
      <div class="slide__text">
        @{{ user.username }}
      </div>
    </TLink>
  </TCarousel>
</template>

<script>
import { getFeaturedCreators, getSuperfeaturedUsers } from '@/api/community';
import userMessages from '@/mixins/user-messages';
import {
  TLink,
  TCarousel,
  TAvatar,
} from '@/components/base';
import Loader from '@/components/Loader.vue';

export default {
  name: 'CommunityCarousel',
  mixins: [userMessages],
  props: {
    setup: {
      required: true,
    },
  },
  components: {
    Loader,
    TCarousel,
    TAvatar,
    TLink,
  },
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  async created() {
    await this.findFeaturedCreators();
  },
  methods: {
    async findFeaturedCreators() {
      this.loading = true;
      try {
        if (this.setup.category === '') {
          const { data } = await getSuperfeaturedUsers();
          this.list = data;
        } else {
          const { data } = await getFeaturedCreators(this.setup);
          this.list = data;
        }
      } catch (e) {
        this.setErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/mixins";

.community-carousel {
  margin-bottom: 32px;

  @include media-lg() {
    margin-bottom: 64px;
  }

  .slick-list {
    overflow: visible;
  }
}

.slide {
  padding: 0 0.75rem;
  -webkit-user-drag: none;

  cursor: pointer;

  &__face {
    width: 13rem;
    height: 13rem;
    margin-bottom: 1rem;

    border-radius: 50%;
  }

  &__text {
    text-align: center;
    color: #333333;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
}
</style>
